import React from 'react';

// Material ui
import { Grid } from '@material-ui/core';

// Components
import Typography from '@components/UI-KIT/Typography';

// Utils
import AmountFormat from '@components/utils/AmountFormat';

// Styles
import './AccountsHero.scss';
import { House, Key } from '@/assets/icons';

interface Props {
    heroData: {
        totalAmountInAccounts: number,
        totalPropietorsAmount: number,
        totalAdministrationsAmount: number
    }
}

const AccountsHero: React.FC<Props> = ({ heroData }) => {

    return (
        <>
            <Grid
                className="AOL-accounts-hero"
            >
                <Grid
                    className="AOL-accounts-hero-cover"
                />
                <Grid
                    className="AOL-accounts-hero-image"
                />
                <Grid
                    className="AOL-accounts-hero-info"
                >
                    <Typography
                        variant="h4"
                        color="white"
                    >
                        Saldo total ARS
                    </Typography>
                    <Typography
                        variant="h1"
                        color="white"
                    >
                        <AmountFormat
                            value={heroData.totalAmountInAccounts}
                        />
                    </Typography>
                    <Grid
                        className="AOL-accounts-separated-amounts"
                    >
                        <Grid
                            container
                            alignItems="center"
                            className="AOL-separated-amounts-container"
                        >
                            <House
                                outlined="square"
                                color="white"
                            />
                            <Grid
                                item
                                className="AOL-separated-amounts-data"
                            >
                                <Typography
                                    variant="input-head"
                                    color="white"
                                >
                                    <AmountFormat
                                        value={heroData.totalAdministrationsAmount}
                                    />
                                </Typography>
                                <Typography
                                    variant="note-regular"
                                    color="white"
                                >
                                    Inmobiliaria
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid
                            container
                            alignItems="center"
                            className="AOL-separated-amounts-container"
                        >
                            <Key
                                outlined="square"
                                color="white"
                            />
                            <Grid
                                item
                                className="AOL-separated-amounts-data"
                            >
                                <Typography
                                    variant="input-head"
                                    color="white"
                                >
                                    <AmountFormat
                                        value={heroData.totalPropietorsAmount}
                                    />
                                </Typography>
                                <Typography
                                    variant="note-regular"
                                    color="white"
                                >
                                    Propietarios
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    );
};

export default AccountsHero;